import { Dentist, User } from 'models/user';
import React, { FC, Fragment, useState } from 'react';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import SelectDentistDialog from 'components/select-dentist-dialog/select-dentist-dialog.component';
import { useTranslation } from 'react-i18next';
import InfoText from 'components/shared/info-text.component';

type OrderDentistProps = {
    currentDentist?: Partial<User>;
    onDentistChanged?: (dentist: Partial<User>) => void;
};
const OrderDentist: FC<OrderDentistProps> = ({ currentDentist, onDentistChanged }) => {
    const { t: translate } = useTranslation(['orders']);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleDentistChanged = (dentist: Partial<User>) => {
        if (onDentistChanged) {
            onDentistChanged(dentist);
        }
        setIsDialogOpen(false);
    };

    return (
        <Fragment>
            <Card variant="outlined" sx={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                    {currentDentist ? (
                        <>
                            <Typography variant="h6" component="div">
                                {currentDentist?.name?.firstName} {currentDentist?.name?.lastName}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                {currentDentist?.email}
                            </Typography>
                        </>
                    ) : (
                        <InfoText text={translate('orders:YOU_NEED_TO_SELECT_DENTIST')} />
                    )}
                </CardContent>
                <CardActions>
                    <Button size="small" onClick={() => setIsDialogOpen(true)} data-test="order-dentist.change-dentist">
                        {translate('orders:CHANGE_DENTIST')}
                    </Button>
                </CardActions>
            </Card>

            <SelectDentistDialog
                open={isDialogOpen}
                onDialogClose={() => setIsDialogOpen(false)}
                onSelect={handleDentistChanged}
                data-test="order-dentist.dialog"
            />
        </Fragment>
    );
};

export default OrderDentist;
